import React, { useEffect, useRef } from 'react'

/** Props do componente RegulamentoModal */
export interface RegulamentoModalProps {
  /** Indica se o modal está visível */
  open: boolean
  /** Função chamada para fechar o modal */
  onClose: () => void
  /** HTML do regulamento a ser exibido */
  regulamentoHtml?: string | null
}

const RegulamentoModal: React.FC<RegulamentoModalProps> = ({ open, onClose, regulamentoHtml }) => {
  const modalRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    if (open) {
      document.addEventListener('keydown', handleKeyDown)
      document.body.classList.add('modal-open')
      modalRef.current?.focus()
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      document.body.classList.remove('modal-open')
    }
  }, [open, onClose])

  if (!open) return null

  return (
    <>
      <div className="modal-backdrop fade show" />
      <div
      className="modal fade show d-block"
      tabIndex={-1}
      role="dialog"
      ref={modalRef}
      style={{ overflow: 'auto' }}
      >
      <div
        className="modal-dialog modal-dialog-centered modal-lg"
        role="document"
        style={{ maxWidth: '90vw', maxHeight: '90vh' }}
      >
        <div className="modal-content" style={{ maxHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
        <div className="modal-header">
          <h5 className="modal-title w-100 text-center">Regulamento</h5>
          <button type="button" className="btn-close" aria-label="Fechar" onClick={onClose}></button>
        </div>
        <div
          className="modal-body text-black"
          style={{ overflowY: 'auto', flex: 1 }}
        >
          <div dangerouslySetInnerHTML={{ __html: regulamentoHtml || '' }} />
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-primary ms-auto" onClick={onClose}>
          Fechar
          </button>
        </div>
        </div>
      </div>
      </div>
    </>
  )
}

export default RegulamentoModal
